import React, {useEffect, useState} from 'react';
import PropTypes from "prop-types";
import {isInternalLink} from "../../helpers/filters";
import {trackEventByUrl} from "../../helpers/events";
import {twillBase} from "../../config/API";

import './CareersFooter.scss';

const CareersFooter = ({info}) => {
    const [links, setLinks] = useState([]);

    if ((!info || info.link_type !== 'careers_page') && (!window.location.pathname.startsWith('/careers/'))) {
        return <React.Fragment />;
    }

    useEffect(() => {
        fetch(`${twillBase}/api/nav-blocks/footer-careers`)
            .then((res) => res.json())
            .then((data) => {

                if (data && data.blocks && data.blocks.length) {

                    const cleanArrayOfLinks = data.blocks.filter(Boolean);
                    console.info("cleanArrayOfLinks", cleanArrayOfLinks);

                    setLinks(cleanArrayOfLinks);
                }

            })
            .catch((err) => console.error("Error fetching menu:", err));
    }, []);

    // Split Links into 2 Columns
    const firstColumnOfLinks = links.slice(0, (Math.ceil(links.length / 2)));
    const secondColumnOfLinks = links.slice((Math.ceil(links.length / 2)));

    // Generate the Menu Spacers
    const firstColumnSpacers = [];
    const secondColumnSpacers = [];

    if (firstColumnOfLinks.length > secondColumnOfLinks.length) {
        const secondColumnSpacersToAdd = firstColumnOfLinks.length - secondColumnOfLinks.length;
        for (let i = 0; i < secondColumnSpacersToAdd; i+=1) {
            secondColumnSpacers.push(<span key={`careersFooterColumn__secondary_spacer_${i}`}>&nbsp;</span>)
        }
    }
    else if (secondColumnOfLinks.length > firstColumnOfLinks.length) {
        const firstColumnSpacersToAdd = secondColumnOfLinks.length - firstColumnOfLinks.length;
        for (let i = 0; i < firstColumnSpacersToAdd; i+=1) {
            firstColumnSpacers.push(<span key={`careersFooterColumn__primary_spacer_${i}`}>&nbsp;</span>)
        }
    }

    return (
        <React.Fragment>
            <footer className="careersFooter">
                <div className="container careersFooter__container">

                    <div className="careersFooter__wrapper">
                        <div className="careersFooterColumn">
                            <div className="careersFooterColumn__row">
                                <img src="/public/images/careers/Careers_Footer_Logo.svg" alt=""/>
                            </div>
                        </div>

                        <div className="careersFooterColumn careersFooterColumn--links">

                            <div className="careersFooterColumn__links">
                                {firstColumnOfLinks.map(link => (
                                    isInternalLink(link.url) && link.url !== '/website-issue' ? (
                                        <a href={link.url.path}>{link.label}</a>
                                    ) : (
                                        <a onClick={() => trackEventByUrl(link.url.path, link.label)}
                                           href={link.url.path}>{link.label}</a>
                                    )
                                ))}
                                {firstColumnSpacers && firstColumnSpacers.length ? firstColumnSpacers.map(spacer => spacer) : null}
                            </div>

                            <div className="careersFooterColumn__links">
                                {secondColumnOfLinks.map(link => (
                                    isInternalLink(link.url) && link.url !== '/website-issue' ? (
                                        <a href={link.url.path}>{link.label}</a>
                                    ) : (
                                        <a onClick={() => trackEventByUrl(link.url.path, link.label)}
                                           href={link.url.path}>{link.label}</a>
                                    )
                                ))}
                                {secondColumnSpacers && secondColumnSpacers.length ? secondColumnSpacers.map(spacer => spacer) : null}
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </React.Fragment>
    );
}

CareersFooter.propTypes = {
    info: PropTypes.shape({
        link_type: PropTypes.string.isRequired,
    }),
};

CareersFooter.defaultProps = {
    info: {link_type: ''},
};


export default CareersFooter;



// WEBPACK FOOTER //
// ./frontend/components/Footer/CareersFooter.jsx